module.exports = __webpack_public_path__ + "img/12.55ac5347.jpg";